import { useCallback } from 'react';
import { OptionTypeBase } from '@beeline.com/bp-design-system';
import { IntlImporters, useImportersIntl } from '../translations/useImportersIntl';
import { AllowedImportType } from './useImporterData';

export const useImporterTypeOptions = () => {
  const intl = useImportersIntl();

  return useCallback(
    (allowedImportTypes?: AllowedImportType[]): OptionTypeBase[] =>
      allowedImportTypes?.map((type) => ({
        value: type,
        label: type?.label ?? (intl[type.id as keyof IntlImporters] as string)
      })) || [],
    [intl]
  );
};
